angular.module("leanlaw").controller("ConfirmUpdateEntriesController", ["$scope", "close", "message", "userService", function ($scope, close, message, userService) {
  $scope.message = message;
  userService.me().then(me => {
    $scope.me = me;
  });
  $scope.confirm = function (properties) {
    close(properties);
  };
  $scope.reject = function () {
    close(false);
  };
  // Close button action can be assigned to a specific response
  $scope.handleCloseButton = function () {
    close($scope.details.ambiguousAnswer || false);
  };
}]);